/**
 * Formats a phone number to UAE international format (+971…) for display and tel: links.
 * Handles values stored without a country code (e.g. "501234567"), with a leading 0,
 * with 00/971 prefixes, or already in +971 form. Non-UAE numbers already carrying a
 * "+" are left untouched.
 */
export function formatPhoneIntl(raw?: string | null): string {
  if (!raw) return '';
  const p = raw.replace(/[\s\-()]/g, '');
  if (p.startsWith('+')) return p;
  if (p.startsWith('00')) return '+' + p.slice(2);
  if (p.startsWith('971')) return '+' + p;
  if (p.startsWith('0')) return '+971' + p.slice(1);
  return '+971' + p;
}
